/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { LayoutUsageTableRow } from 'cio/components/layout-usage-table';

interface RowArgs {
  row: LayoutUsageTableRow;
}

export default class Row extends Component<RowArgs> {
  @tracked isExpanded = false;

  @action
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }
}
